<template>
    <div class="Settings">
        <router-view />
    </div>
</template>

<script>
export default {

    data() {
        return {
            routeName: this.$route.name
        };
    },
    watch: {
        $route(val) {
            this.routeName = val.name;
        }
    },

    methods: {
        goTo(el) {
            const element = document.querySelector(el);
            element.scrollIntoView({ behavior: 'smooth', block: "center", inline: "nearest" });
        }
    }
};
</script>

<style lang="scss">
.Settings {
    display: flex;
    flex-flow: row wrap;
    flex: 0 0 100%;
    width: 100%;
    padding-top: 2rem;
}

.EmailSettingMenu {
    list-style: none !important;
    margin: 0 !important;
    padding: 0 0 0 12px !important;

    a {
        color: $secondary-500 !important;
    }
}

</style>
